<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.new')" :icon="'mdi-plus'" :color="'quaternary'"
    :disabled="false" :outlined="false" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NewEntityBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  data() {
    return {};
  },
  created() { },
  mounted() { },
  methods: {
    action() {
      var to = this.$route.meta?.newEntityBtnTo;
      //console.log(to);
      this.$router.push(to)
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped></style>
